import { Calendar, Music, Clock, MapPin } from "lucide-react";
import { VALUES } from "../data/content";
import { VideoLightbox } from "./VideoLightbox";

// Un ícono por estadística, en el mismo orden que VALUES en content.js
// (trayectoria, repertorio, atención, cobertura).
const VALUE_ICONS = [Calendar, Music, Clock, MapPin];

/** Tarjeta de estadística: ícono, número, título en una sola línea, descripción */
const ValueCard = ({ v, i, total, Icon }) => (
    <article
        data-testid={`value-card-${i}`}
        className="hover-lift group relative flex flex-col rounded-2xl border border-gold/20 bg-card p-8 transition-all duration-500 md:p-9"
    >
        {/* Top row — icon + index */}
        <div className="flex items-center justify-between">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-gold/30 bg-gold/5 text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-black">
                <Icon className="h-5 w-5" />
            </div>
            <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-muted-foreground">
                {String(i + 1).padStart(2, "0")}/{String(total).padStart(2, "0")}
            </span>
        </div>

        {/* Main stat */}
        <div className="mt-8">
            <div className="font-display text-6xl leading-none text-foreground sm:text-7xl">
                {v.stat}
            </div>
            <div className="mt-3 whitespace-nowrap text-xs font-bold uppercase tracking-[0.15em] text-gold">
                {v.title}
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                {v.label}
            </div>
        </div>

        {/* Description */}
        <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
            {v.desc}
        </p>

        {/* Bottom row */}
        <div className="mt-auto pt-6">
            <div className="flex items-center justify-between border-t border-border pt-4 text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
                <span>Mariachi Mexicanísimo</span>
                <span className="text-gold">Pasión mexicana</span>
            </div>
        </div>
    </article>
);

export const Nosotros = () => {
    return (
        <section
            id="nosotros"
            data-testid="nosotros-section"
            className="relative py-24 md:py-32"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                {/* Header */}
                <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-20">
                    <div className="lg:col-span-5">
                        <div className="mb-6 inline-flex items-center gap-3">
                            <span className="h-px w-12 bg-gold" />
                            <span className="text-xs font-semibold uppercase tracking-[0.35em] text-gold">
                                Nosotros
                            </span>
                        </div>
                        <h2 className="font-display text-4xl leading-tight text-balance text-foreground sm:text-5xl md:text-6xl">
                            Momentos que
                            <span className="block text-balance text-gold">se viven con el alma.</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-7">
                        <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
                            En <strong className="text-foreground">Mariachi Mexicanísimo</strong> nos
                            apasiona compartir con ustedes, acompañarlos en sus momentos
                            especiales y ser parte de sus alegrías. Cada nota, cada zapateo y
                            cada canción está hecha para que el recuerdo dure toda la vida en
                            Armenia, Quindío y todo el Eje Cafetero.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <div className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 bg-gold/5">
                                <span className="font-display text-lg text-gold">F</span>
                            </div>
                            <div>
                                <div className="font-display text-sm text-foreground">
                                    Felipe Hurtado
                                </div>
                                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
                                    Director Musical
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Video */}
                <div className="mt-14">
                    <VideoLightbox />
                </div>

                {/* Stat cards — cada una con ícono, espacio propio y bordes redondeados */}
                <div className="mt-20 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {VALUES.map((v, i) => (
                        <ValueCard
                            key={v.title}
                            v={v}
                            i={i}
                            total={VALUES.length}
                            Icon={VALUE_ICONS[i]}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Nosotros;
